import type { Egg } from "@/lib/eggs-data";
import eggCommon from "@/assets/pal-items/egg-common.webp.asset.json";
import eggDamp from "@/assets/pal-items/egg-damp.webp.asset.json";
import eggDark from "@/assets/pal-items/egg-dark.webp.asset.json";
import eggDragon from "@/assets/pal-items/egg-dragon.webp.asset.json";
import eggElectric from "@/assets/pal-items/egg-electric.webp.asset.json";
import eggFrozen from "@/assets/pal-items/egg-frozen.webp.asset.json";
import eggRocky from "@/assets/pal-items/egg-rocky.webp.asset.json";
import eggScorching from "@/assets/pal-items/egg-scorching.webp.asset.json";
import eggVerdant from "@/assets/pal-items/egg-verdant.webp.asset.json";

/**
 * Official Palworld egg artwork. Each egg family maps to the real in-game egg
 * item icon, served from the site CDN and lazy-loaded. Used under fair use for
 * an unofficial fan wiki; Palworld egg art is © Pocketpair.
 */
const FAMILY_ART: Record<string, string> = {
  Common: eggCommon.url,
  Food: eggCommon.url,
  Damp: eggDamp.url,
  Dark: eggDark.url,
  Dragon: eggDragon.url,
  Electric: eggElectric.url,
  Frozen: eggFrozen.url,
  Rocky: eggRocky.url,
  Scorching: eggScorching.url,
  Verdant: eggVerdant.url,
};

export function EggArt({ egg, size = 220 }: { egg: Egg; size?: number }) {
  const src = FAMILY_ART[egg.family] ?? eggCommon.url;
  return (
    <div
      className="relative mx-auto flex w-full items-center justify-center"
      style={{
        maxWidth: size,
        background: `radial-gradient(circle at 50% 45%, ${egg.color}55, transparent 70%)`,
      }}
    >
      <img
        src={src}
        alt={`${egg.name} — official Palworld ${egg.element} egg item icon`}
        loading="lazy"
        decoding="async"
        width={size}
        height={size}
        className="h-auto w-full object-contain drop-shadow-[0_10px_18px_rgba(0,0,0,0.45)]"
      />
    </div>
  );
}
